<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-form @submit.prevent="copy">
        <q-card-section>
          <div class="text-h6">Изменить даты фотографий</div>
        </q-card-section>
        <q-card-section>
          <q-input v-model="newDate" label="Дата">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="newDate" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input v-model.number="latitude" label="Широта" type="number" :rules="[latitudeRule]"/>
          <q-input v-model.number="longitude" label="Долгота" type="number" :rules="[longitudeRule]"/>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn no-caps label="Обновить" type="submit"
                 color="primary"/>
          <q-btn :disable="copied" color="primary" label="Отмена" no-caps @click="onDialogCancel"/>
        </q-card-actions>
      </q-form>

    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import {useDialogPluginComponent, useQuasar} from 'quasar'
import {ref} from 'vue'
import {useDayJs} from '../composables/dayjs';
import {latitudeRule, longitudeRule} from "../util/rules";


defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])


const $q = useQuasar()


const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()


const newDate = ref(null)
const latitude = ref(null)
const longitude = ref(null)

async function copy() {
  onDialogOK(
      {
        newDate: newDate.value,
        latitude: latitude.value,
        longitude: longitude.value
      }
  )
}
</script>